/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Input, ModalBody, ModalFooter, ModalHeader, Select, SelectItem } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { SettingsService } from '../../../../services';
import { getCountryFlagUrl, getOnlyNumbers } from '../../../../utils';
import CountryFlag from '../../../../components/country-flag';

const statuses = [
  { value: '1', label: 'Activo' },
  { value: '0', label: 'Inactivo' },
];

const ModalCreate = ({ item, onClose, onSuccess }) => {
  const { banks, dniTypes, form, isLoading, onChange, onSubmit, paymentMethods, phoneCodes } = useForm(item, onSuccess);

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">{item ? 'Editar' : 'Nueva'} cuenta de pago</ModalHeader>
      <ModalBody className="gap-4">
        <Input
          label="Beneficiario"
          labelPlacement="outside"
          placeholder=" "
          radius="sm"
          variant="bordered"
          value={form.name}
          onValueChange={v => onChange(v, 'name')}
        />
        <Select
          label="Entidad bancaria"
          labelPlacement="outside"
          placeholder=" "
          variant="bordered"
          radius="sm"
          classNames={{ label: 'font-semibold' }}
          disallowEmptySelection={true}
          selectedKeys={[form.bank_id]}
          onSelectionChange={v => onChange(v.currentKey, 'bank_id')}
        >
          <SelectItem key="" value="" hidden>Selecciona</SelectItem>
          {banks.map((item) => (
            <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
          ))}
        </Select>
        <Input
          label="Número de cuenta"
          labelPlacement="outside"
          placeholder=" "
          radius="sm"
          variant="bordered"
          value={form.account_number}
          onValueChange={v => onChange(getOnlyNumbers(v), 'account_number')}
        />
        <Select
          label="Tipo de pago"
          labelPlacement="outside"
          placeholder=" "
          variant="bordered"
          radius="sm"
          classNames={{ label: 'font-semibold' }}
          disallowEmptySelection={true}
          selectedKeys={[form.payment_method_id]}
          onSelectionChange={v => onChange(v.currentKey, 'payment_method_id')}
          startContent={<CountryFlag src={getCountryFlagUrl(form.payment_method?.country_id)} />}
        >
          {paymentMethods.map((item) => (
            <SelectItem
              key={item.value}
              value={item.value}
              startContent={<CountryFlag src={getCountryFlagUrl(item?.country_id)} />}
              classNames={{ title: 'min-w-48' }}
            >
              {item.label}
            </SelectItem>
          ))}
        </Select>

        <Input
          label="DNI/CI"
          labelPlacement="outside"
          placeholder=" "
          startContent={(
            <Select
              aria-label="Tipo de documento"
              placeholder="Selecciona"
              variant="flat"
              classNames={{ trigger: 'border-0 max-w-32' }}
              disallowEmptySelection={true}
              selectedKeys={[form._dni_type_id]}
              onSelectionChange={v => onChange(v.currentKey, '_dni_type_id')}
            >
              <SelectItem key="J-" value="J-" classNames={{ title: 'min-w-48' }}>J-</SelectItem>
              {dniTypes.map((item) => (
                <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
              ))}
            </Select>
          )}
          variant="bordered"
          radius="sm"
          classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
          value={form._dni}
          onValueChange={v => onChange(getOnlyNumbers(v), '_dni')}
        />

        <Input
          label="Teléfono"
          labelPlacement="outside"
          placeholder=" "
          startContent={(
            <Select
              aria-label="Código de área"
              variant="flat"
              placeholder="Selecciona"
              classNames={{ trigger: 'border-0 max-w-32 pl-1 pr-0' }}
              disallowEmptySelection={true}
              selectedKeys={[form._phonecode_id]}
              onSelectionChange={v => onChange(v.currentKey, '_phonecode_id')}
              startContent={<CountryFlag phoneCodeId={form._phonecode_id} phoneCodes={phoneCodes} />}
            >
              {phoneCodes.map((item) => (
                <SelectItem
                  key={item.value}
                  value={item.value}
                  startContent={<CountryFlag src={item.url} />}
                  classNames={{ title: 'min-w-48' }}
                >
                  {item.label}
                </SelectItem>
              ))}
            </Select>
          )}
          variant="bordered"
          radius="sm"
          classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
          value={form._phone}
          onValueChange={v => onChange(getOnlyNumbers(v), '_phone')}
        />

        <Input
          label="Correo"
          labelPlacement="outside"
          placeholder=" "
          radius="sm"
          variant="bordered"
          value={form.email}
          onValueChange={v => onChange(v, 'email')}
        />

        <Select
          label="Estatus"
          labelPlacement="outside"
          placeholder=" "
          variant="bordered"
          radius="sm"
          classNames={{ label: 'font-semibold' }}
          disallowEmptySelection={true}
          selectedKeys={[form.status]}
          onSelectionChange={v => onChange(v.currentKey, 'status')}
        >
          {statuses.map((item) => (
            <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
          ))}
        </Select>
      </ModalBody>

      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button className="bg-green" color="primary" onPress={onSubmit} isLoading={isLoading} isDisabled={isLoading}>
          Guardar
        </Button>
      </ModalFooter>
    </>
  )
}

const useForm = (item, onSuccess) => {
  const initialForm = {
    payment_method_id: '',
    payment_method: null,
    bank_id: '',
    name: '',
    account_number: '',
    _dni_type_id: '',
    _dni: '',
    dni: '',
    _phonecode_id: '',
    _phone: '',
    phone: '',
    email: '',
    status: '',
  };
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [phoneCodes, setPhoneCodes] = useState([]);
  const [dniTypes, setDniTypes] = useState([]);
  const [banks, setBanks] = useState([]);

  const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));
  const toSelectSameValue = (items) => items.map(x => ({ ...x, value: String(x.name), label: x.name }));

  const getSelects = async () => {
    const selects = await SettingsService.admin.getPaymentMethodsInfoSelects();
    setPaymentMethods(toSelect(selects.payment_methods));
    setPhoneCodes(toSelectSameValue(selects.phonecodes));
    setDniTypes(toSelectSameValue(selects.document_types));
    setBanks(toSelect(selects.banks));

    if (item) {
      const _phonecode_id = item.phone
        ? String(item.phone.substring(0, 3) || '')
        : '';

      const _dni_type_id = item.dni
        ? String(item.dni.split('-')[0] + '-')
        : '';

      const payment_method = selects.payment_methods.find(x => x.id === +item.payment_method_id);

      setForm(s => ({
        ...s,
        payment_method,
        _phonecode_id,
        _dni_type_id,
      }));
    }
  }

  const onChange = (value, target) => {
    setForm(s => {
      const payment_method = (target === 'payment_method_id')
        ? paymentMethods.find(x => x.value === value)
        : s.payment_method;

      return { ...s, payment_method, [target]: value };
    });
  }

  const onError = (msg) => {
    toast.error(msg);
    return false;
  }

  const isValidForm = () => {
    if (!form.name)
      return onError('Debe indicar el nombre');

    if (!form.payment_method_id)
      return onError('Debe indicar el tipo de pago');

    if (!form._dni_type_id)
      return onError('Debe indicar el tipo de documento');

    if (!form._dni)
      return onError('Debe indicar el documento de identidad');

    if (!form._phonecode_id)
      return onError('Debe indicar el código de área');

    if (!form._phone)
      return onError('Debe indicar el teléfono');

    if (!form.status)
      return onError('Debe indicar el estatus');

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;
    setIsLoading(true);

    try {
      const _form = {
        ...form,
        dni: `${form._dni_type_id}${form._dni}`,
        phone: `${form._phonecode_id}${form._phone}`,
      };

      if (!!item) {
        await SettingsService.admin.updatePaymentMethodInfo(_form);
        toast.success('Cuenta actualizada correctamente');
      } else {
        await SettingsService.admin.createPaymentMethodsInfo(_form);
        toast.success('Cuenta creada correctamente');
      }

      onSuccess();

    } catch (error) {
      //
    }

    setIsLoading(false);
  }

  useEffect(() => {
    if (!!item) {
      const dniSplit = item?.dni ? item?.dni?.split('-') : [];

      setForm({
        id: item?.id,
        payment_method_id: item?.payment_method_id ? String(item.payment_method_id) : '',
        bank_id: item?.bank_id ? String(item.bank_id) : '',
        name: item?.name ?? '',
        account_number: item?.account_number ?? '',
        _dni_type_id: dniSplit?.length > 1 ? dniSplit[0] + '-' : '',
        _dni: dniSplit?.length > 1 ? dniSplit[1] : '',
        dni: item?.dni ?? '',
        _phonecode_id: '',
        _phone: item?.phone ? item.phone.substring(3) : '',
        phone: item?.phone ?? '',
        email: item?.email ?? '',
        status: String(item?.status ?? ''),
      });
    }

    getSelects();
  }, []);

  return {
    banks,
    dniTypes,
    form,
    isLoading,
    onChange,
    onSubmit,
    paymentMethods,
    phoneCodes,
  }
}

export default ModalCreate